// extracted by mini-css-extract-plugin
export var svgDefs = "SVGDefs_svgDefs__+QGrT";